module.exports = __webpack_public_path__ + "media/images/link_process-897bdc167f767ad506984e9307e2a797.svg";